import { TenantConfig } from '@/types/TenantConfig'

const pink = '#FF33D2'
const offWhite = '#F2F2F3'
const darkGrey = '#323434'
const lightPink = '#FFB3EE'

export const brisbanefestival: TenantConfig = {
  logo: 'assets/brisbanefestival/static/logo.png',

  themeOptions: {
    primaryColor: pink,
    secondaryColor: lightPink,
    logoHeight: '50px',
    headerHeight: '80px',
    headerBackground: pink,
    pageBackgroundColor: offWhite,
    footerBackgroundColor: pink,
    footerTextColor: darkGrey,
  },

  componentOptions: {
    stripeCreditCard: {
      font: {
        src: 'https://fonts.gstatic.com/s/worksans/v18/QGYsz_wNahGAdqQ43Rh_fKDptfpA4Q.woff2',
        family: '"Work Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
      },
    },
  },
}
